<template>
  <!--
Afișează conținutul doar dacă utilizatorul are rolul de Admin sau Web Developer.
`$gate` este un sistem de permisiuni personalizat (probabil definit global în aplicație).
Metodele `isAdmin()` și `isWebDev()` verifică dacă utilizatorul are unul dintre aceste roluri.
<div v-if="this.$gate.isAdmin() || this.$gate.isWebDev()">
-->
  <div>
    <div class="d-flex flex-column flex-column-fluid">
      <div class="app-toolbar py-3 py-lg-6">
        <div class="app-container container-xxl d-flex flex-stack">
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted" @click="$router.go(-1)" style="cursor: pointer;">
              Inapoi
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-500 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">Prima pagina</li>
          </ul>
        </div>
      </div>
      <div class="app-content flex-column-fluid">
        <!--begin::Content container-->
        <div class="app-container container-xxl">
          <!--begin::Row-->
          <div class="row g-5 g-xl-10 mb-xl-10">
            <!--begin::Col-->
            <div class="col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10">

              <!--begin::Card widget 4-->
              <div class="card card-flush h-md-50 mb-5 mb-xl-10">
                <!--begin::Header-->
                <div class="card-header pt-5">
                  <!--begin::Title-->
                  <div class="card-title d-flex flex-column">
                    <!--begin::Info-->
                    <div class="d-flex align-items-center">
                      <!--begin::Currency-->
                      <span class="fs-4 fw-semibold text-gray-500 me-1 align-self-start">$</span>
                      <!--end::Currency-->

                      <!--begin::Amount-->
                      <span class="fs-2hx fw-bold text-gray-900 me-2 lh-1 ls-n2">69,700</span>
                      <!--end::Amount-->

                      <!--begin::Badge-->
                      <span class="badge badge-light-success fs-base">
                        <i class="ki-duotone ki-arrow-up fs-5 text-success ms-n1"><span class="path1"></span><span
                            class="path2"></span></i>
                        2.2%
                      </span>
                      <!--end::Badge-->
                    </div>
                    <!--end::Info-->

                    <!--begin::Subtitle-->
                    <span class="text-gray-500 pt-1 fw-semibold fs-6">Expected Earnings</span>
                    <!--end::Subtitle-->
                  </div>
                  <!--end::Title-->
                </div>
                <!--end::Header-->

                <!--begin::Card body-->
                <div class="card-body pt-2 pb-4 d-flex align-items-center">
                  <!--begin::Chart-->
                  <div class="d-flex flex-center me-5 pt-2">
                    <div id="kt_card_widget_4_chart" style="min-width: 70px; min-height: 70px" data-kt-size="70"
                      data-kt-line="11">
                      <span></span><canvas height="70" width="70"></canvas>
                    </div>
                  </div>
                  <!--end::Chart-->

                  <!--begin::Labels-->
                  <div class="d-flex flex-column content-justify-center w-100">
                    <!--begin::Label-->
                    <div class="d-flex fs-6 fw-semibold align-items-center">
                      <!--begin::Bullet-->
                      <div class="bullet w-8px h-6px rounded-2 bg-danger me-3"></div>
                      <!--end::Bullet-->

                      <!--begin::Label-->
                      <div class="text-gray-500 flex-grow-1 me-4">Shoes</div>
                      <!--end::Label-->

                      <!--begin::Stats-->
                      <div class="fw-bolder text-gray-700 text-xxl-end">$7,660</div>
                      <!--end::Stats-->
                    </div>
                    <!--end::Label-->

                    <!--begin::Label-->
                    <div class="d-flex fs-6 fw-semibold align-items-center my-3">
                      <!--begin::Bullet-->
                      <div class="bullet w-8px h-6px rounded-2 bg-primary me-3"></div>
                      <!--end::Bullet-->

                      <!--begin::Label-->
                      <div class="text-gray-500 flex-grow-1 me-4">Gaming</div>
                      <!--end::Label-->

                      <!--begin::Stats-->
                      <div class="fw-bolder text-gray-700 text-xxl-end">$2,820</div>
                      <!--end::Stats-->
                    </div>
                    <!--end::Label-->

                    <!--begin::Label-->
                    <div class="d-flex fs-6 fw-semibold align-items-center">
                      <!--begin::Bullet-->
                      <div class="bullet w-8px h-6px rounded-2 me-3" style="background-color: #E4E6EF"></div>
                      <!--end::Bullet-->

                      <!--begin::Label-->
                      <div class="text-gray-500 flex-grow-1 me-4">Others</div>
                      <!--end::Label-->

                      <!--begin::Stats-->
                      <div class=" fw-bolder text-gray-700 text-xxl-end">$45,257</div>
                      <!--end::Stats-->
                    </div>
                    <!--end::Label-->
                  </div>
                  <!--end::Labels-->
                </div>
                <!--end::Card body-->
              </div>
              <!--end::Card widget 4-->

              <!--begin::Card widget 5-->
              <div class="card card-flush h-md-50 mb-xl-10">
                <!--begin::Header-->
                <div class="card-header pt-5">
                  <!--begin::Title-->
                  <div class="card-title d-flex flex-column">
                    <!--begin::Info-->
                    <div class="d-flex align-items-center">
                      <!--begin::Amount-->
                      <span class="fs-2hx fw-bold text-gray-900 me-2 lh-1 ls-n2">1,836</span>
                      <!--end::Amount-->

                      <!--begin::Badge-->
                      <span class="badge badge-light-danger fs-base">
                        <i class="ki-duotone ki-arrow-down fs-5 text-danger ms-n1"><span class="path1"></span><span
                            class="path2"></span></i>
                        2.2%
                      </span>
                      <!--end::Badge-->
                    </div>
                    <!--end::Info-->

                    <!--begin::Subtitle-->
                    <span class="text-gray-500 pt-1 fw-semibold fs-6">Orders This Month</span>
                    <!--end::Subtitle-->
                  </div>
                  <!--end::Title-->
                </div>
                <!--end::Header-->

                <!--begin::Card body-->
                <div class="card-body d-flex align-items-end pt-0">
                  <!--begin::Progress-->
                  <div class="d-flex align-items-center flex-column mt-3 w-100">
                    <div class="d-flex justify-content-between w-100 mt-auto mb-2">
                      <span class="fw-bolder fs-6 text-gray-900">1,048 to Goal</span>
                      <span class="fw-bold fs-6 text-gray-500">62%</span>
                    </div>

                    <div class="h-8px mx-3 w-100 bg-light-success rounded">
                      <div class="bg-success rounded h-8px" role="progressbar" style="width: 62%;" aria-valuenow="50"
                        aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                  <!--end::Progress-->
                </div>
                <!--end::Card body-->
              </div>
              <!--end::Card widget 5-->
            </div>
            <!--end::Col-->

            <!--begin::Col-->
            <div class="col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10">
              <!--begin::Card widget 6-->
              <div class="card card-flush  h-md-50 mb-5 mb-xl-10">
                <!--begin::Header-->
                <div class="card-header pt-5">
                  <!--begin::Title-->
                  <div class="card-title d-flex flex-column">
                    <!--begin::Info-->
                    <div class="d-flex align-items-center">
                      <!--begin::Currency-->
                      <span class="fs-4 fw-semibold text-gray-500 me-1 align-self-start">$</span>
                      <!--end::Currency-->

                      <!--begin::Amount-->
                      <span class="fs-2hx fw-bold text-gray-900 me-2 lh-1 ls-n2">2,420</span>
                      <!--end::Amount-->

                      <!--begin::Badge-->
                      <span class="badge badge-light-success fs-base">
                        <i class="ki-duotone ki-arrow-up fs-5 text-success ms-n1"><span class="path1"></span><span
                            class="path2"></span></i>
                        2.6%
                      </span>
                      <!--end::Badge-->
                    </div>
                    <!--end::Info-->

                    <!--begin::Subtitle-->
                    <span class="text-gray-500 pt-1 fw-semibold fs-6">Average Daily Sales</span>
                    <!--end::Subtitle-->
                  </div>
                  <!--end::Title-->
                </div>
                <!--end::Header-->

                <!--begin::Card body-->
                <div class="card-body d-flex align-items-end px-0 pb-0">
                  <!--begin::Chart-->
                  <div id="kt_card_widget_6_chart" class="w-100" style="height: 80px; min-height: 80px;">
                    <div id="apexchartslvd9i8en" class="apexcharts-canvas apexchartslvd9i8en apexcharts-theme-light"
                      style="width: 289px; height: 80px;"><svg id="SvgjsSvg1244" width="289" height="80"
                        xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:svgjs="http://svgjs.dev" class="apexcharts-svg" xmlns:data="ApexChartsNS"
                        transform="translate(0, 0)" style="background: transparent;">
                        <foreignObject x="0" y="0" width="289" height="80">
                          <div class="apexcharts-legend" xmlns="http://www.w3.org/1999/xhtml" style="max-height: 40px;">
                          </div>
                        </foreignObject>
                        <g id="SvgjsG1290" class="apexcharts-yaxis" rel="0" transform="translate(-18, 0)"></g>
                        <g id="SvgjsG1246" class="apexcharts-inner apexcharts-graphical"
                          transform="translate(35.43888888888889, 0)">
                          <defs id="SvgjsDefs1245">
                            <clipPath id="gridRectMasklvd9i8en">
                              <rect id="SvgjsRect1248" width="281.99999999999994" height="89" x="-27.93888888888889"
                                y="-4.5" rx="0" ry="0" opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0"
                                fill="#fff"></rect>
                            </clipPath>
                            <clipPath id="forecastMasklvd9i8en"></clipPath>
                            <clipPath id="nonForecastMasklvd9i8en"></clipPath>
                            <clipPath id="gridRectMarkerMasklvd9i8en">
                              <rect id="SvgjsRect1249" width="230.1222222222222" height="84" x="-2" y="-2" rx="0" ry="0"
                                opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0" fill="#fff"></rect>
                            </clipPath>
                          </defs>
                          <g id="SvgjsG1269" class="apexcharts-grid">
                            <g id="SvgjsG1270" class="apexcharts-gridlines-horizontal" style="display: none;">
                              <line id="SvgjsLine1273" x1="-21.43888888888889" y1="0" x2="247.5611111111111" y2="0"
                                stroke="#dbdfe9" stroke-dasharray="4" stroke-linecap="butt" class="apexcharts-gridline">
                              </line>
                              <line id="SvgjsLine1274" x1="-21.43888888888889" y1="20" x2="247.5611111111111" y2="20"
                                stroke="#dbdfe9" stroke-dasharray="4" stroke-linecap="butt" class="apexcharts-gridline">
                              </line>
                              <line id="SvgjsLine1275" x1="-21.43888888888889" y1="40" x2="247.5611111111111" y2="40"
                                stroke="#dbdfe9" stroke-dasharray="4" stroke-linecap="butt" class="apexcharts-gridline">
                              </line>
                              <line id="SvgjsLine1276" x1="-21.43888888888889" y1="60" x2="247.5611111111111" y2="60"
                                stroke="#dbdfe9" stroke-dasharray="4" stroke-linecap="butt" class="apexcharts-gridline">
                              </line>
                              <line id="SvgjsLine1277" x1="-21.43888888888889" y1="80" x2="247.5611111111111" y2="80"
                                stroke="#dbdfe9" stroke-dasharray="4" stroke-linecap="butt" class="apexcharts-gridline">
                              </line>
                            </g>
                            <g id="SvgjsG1271" class="apexcharts-gridlines-vertical" style="display: none;"></g>
                            <line id="SvgjsLine1279" x1="0" y1="80" x2="226.1222222222222" y2="80" stroke="transparent"
                              stroke-dasharray="0" stroke-linecap="butt"></line>
                            <line id="SvgjsLine1278" x1="0" y1="1" x2="0" y2="80" stroke="transparent"
                              stroke-dasharray="0" stroke-linecap="butt"></line>
                          </g>
                          <g id="SvgjsG1272" class="apexcharts-grid-borders" style="display: none;"></g>
                          <g id="SvgjsG1250" class="apexcharts-bar-series apexcharts-plot-series">
                            <g id="SvgjsG1251" class="apexcharts-series" rel="1" seriesName="Sales" data:realIndex="0">
                              <path id="SvgjsPath1256"
                                d="M-10.363935185185184 74.001L-10.363935185185184 56.001C-10.363935185185184 53.001 -7.363935185185184 50.001 -4.363935185185184 50.001L-4.363935185185184 50.001C-1.5 50.001 1.3639351851851842 53.001 1.3639351851851842 56.001L1.3639351851851842 74.001C1.3639351851851842 77.001 -1.6360648148148158 80.001 -4.636064814814816 80.001L-4.636064814814816 80.001C-7.5 80.001 -10.363935185185184 77.001 -10.363935185185184 74.001C-10.363935185185184 74.001 -10.363935185185184 74.001 -10.363935185185184 74.001 "
                                fill="rgba(62,151,255,0.85)" fill-opacity="1" stroke="transparent" stroke-opacity="1"
                                stroke-linecap="round" stroke-width="9" stroke-dasharray="0" class="apexcharts-bar-area"
                                index="0" clip-path="url(#gridRectMasklvd9i8en)"
                                pathTo="M -10.363935185185184 74.001 L -10.363935185185184 56.001 C -10.363935185185184 53.001 -7.363935185185184 50.001 -4.363935185185184 50.001 L -4.363935185185184 50.001 C -1.5 50.001 1.3639351851851842 53.001 1.3639351851851842 56.001 L 1.3639351851851842 74.001 C 1.3639351851851842 77.001 -1.6360648148148158 80.001 -4.636064814814816 80.001 L -4.636064814814816 80.001 C -7.5 80.001 -10.363935185185184 77.001 -10.363935185185184 74.001 Z "
                                pathFrom="M -10.363935185185184 80.001 L -10.363935185185184 80.001 L 1.3639351851851842 80.001 L 1.3639351851851842 80.001 L 1.3639351851851842 80.001 L 1.3639351851851842 80.001 L 1.3639351851851842 80.001 L -10.363935185185184 80.001 Z"
                                cy="50" cx="5.863935185185184" j="0" val="30" barHeight="30" barWidth="20.72787037037037">
                              </path>
                              <path id="SvgjsPath1258"
                                d="M27.323101851851852 74.001L27.323101851851852 26.001000000000005C27.323101851851852 23.001000000000005 30.323101851851852 20.001000000000005 33.32310185185185 20.001000000000005L33.32310185185185 20.001000000000005C36.18703703703704 20.001000000000005 39.05097222222222 23.001000000000005 39.05097222222222 26.001000000000005L39.05097222222222 74.001C39.05097222222222 77.001 36.05097222222222 80.001 33.05097222222222 80.001L33.05097222222222 80.001C30.187037037037037 80.001 27.323101851851852 77.001 27.323101851851852 74.001C27.323101851851852 74.001 27.323101851851852 74.001 27.323101851851852 74.001 "
                                fill="rgba(62,151,255,0.85)" fill-opacity="1" stroke="transparent" stroke-opacity="1"
                                stroke-linecap="round" stroke-width="9" stroke-dasharray="0" class="apexcharts-bar-area"
                                index="0" clip-path="url(#gridRectMasklvd9i8en)"
                                pathTo="M 27.323101851851852 74.001 L 27.323101851851852 26.001 C 27.323101851851852 23.001 30.323101851851852 20.001 33.32310185185185 20.001 L 33.32310185185185 20.001 C 36.18703703703704 20.001 39.05097222222222 23.001 39.05097222222222 26.001 L 39.05097222222222 74.001 C 39.05097222222222 77.001 36.05097222222222 80.001 33.05097222222222 80.001 L 33.05097222222222 80.001 C 30.187037037037037 80.001 27.323101851851852 77.001 27.323101851851852 74.001 Z "
                                pathFrom="M 27.323101851851852 80.001 L 27.323101851851852 80.001 L 39.05097222222222 80.001 L 39.05097222222222 80.001 L 39.05097222222222 80.001 L 39.05097222222222 80.001 L 39.05097222222222 80.001 L 27.323101851851852 80.001 Z"
                                cy="20" cx="43.55097222222222" j="1" val="60" barHeight="60" barWidth="20.72787037037037">
                              </path>
                              <path id="SvgjsPath1260"
                                d="M65.01013888888889 74.001L65.01013888888889 33.001000000000005C65.01013888888889 30.001000000000005 68.01013888888889 27.001000000000005 71.01013888888889 27.001000000000005L71.01013888888889 27.001000000000005C73.87407407407407 27.001000000000005 76.73800925925926 30.001000000000005 76.73800925925926 33.001000000000005L76.73800925925926 74.001C76.73800925925926 77.001 73.73800925925926 80.001 70.73800925925926 80.001L70.73800925925926 80.001C67.87407407407407 80.001 65.01013888888889 77.001 65.01013888888889 74.001C65.01013888888889 74.001 65.01013888888889 74.001 65.01013888888889 74.001 "
                                fill="rgba(62,151,255,0.85)" fill-opacity="1" stroke="transparent" stroke-opacity="1"
                                stroke-linecap="round" stroke-width="9" stroke-dasharray="0" class="apexcharts-bar-area"
                                index="0" clip-path="url(#gridRectMasklvd9i8en)"
                                pathTo="M 65.01013888888889 74.001 L 65.01013888888889 33.001000000000005 C 65.01013888888889 30.001000000000005 68.01013888888889 27.001 71.01013888888889 27.001 L 71.01013888888889 27.001 C 73.87407407407407 27.001 76.73800925925926 30.001000000000005 76.73800925925926 33.001000000000005 L 76.73800925925926 74.001 C 76.73800925925926 77.001 73.73800925925926 80.001 70.73800925925926 80.001 L 70.73800925925926 80.001 C 67.87407407407407 80.001 65.01013888888889 77.001 65.01013888888889 74.001 Z "
                                pathFrom="M 65.01013888888889 80.001 L 65.01013888888889 80.001 L 76.73800925925926 80.001 L 76.73800925925926 80.001 L 76.73800925925926 80.001 L 76.73800925925926 80.001 L 76.73800925925926 80.001 L 65.01013888888889 80.001 Z"
                                cy="27" cx="81.23800925925926" j="2" val="53" barHeight="53" barWidth="20.72787037037037">
                              </path>
                              <path id="SvgjsPath1262"
                                d="M102.69717592592592 74.001L102.69717592592592 41.001C102.69717592592592 38.001 105.69717592592592 35.001 108.69717592592592 35.001L108.69717592592592 35.001C111.5611111111111 35.001 114.42504629629629 38.001 114.42504629629629 41.001L114.42504629629629 74.001C114.42504629629629 77.001 111.42504629629629 80.001 108.42504629629629 80.001L108.42504629629629 80.001C105.5611111111111 80.001 102.69717592592592 77.001 102.69717592592592 74.001C102.69717592592592 74.001 102.69717592592592 74.001 102.69717592592592 74.001 "
                                fill="rgba(62,151,255,0.85)" fill-opacity="1" stroke="transparent" stroke-opacity="1"
                                stroke-linecap="round" stroke-width="9" stroke-dasharray="0" class="apexcharts-bar-area"
                                index="0" clip-path="url(#gridRectMasklvd9i8en)"
                                pathTo="M 102.69717592592592 74.001 L 102.69717592592592 41.001 C 102.69717592592592 38.001 105.69717592592592 35.001 108.69717592592592 35.001 L 108.69717592592592 35.001 C 111.5611111111111 35.001 114.42504629629629 38.001 114.42504629629629 41.001 L 114.42504629629629 74.001 C 114.42504629629629 77.001 111.42504629629629 80.001 108.42504629629629 80.001 L 108.42504629629629 80.001 C 105.5611111111111 80.001 102.69717592592592 77.001 102.69717592592592 74.001 Z "
                                pathFrom="M 102.69717592592592 80.001 L 102.69717592592592 80.001 L 114.42504629629629 80.001 L 114.42504629629629 80.001 L 114.42504629629629 80.001 L 114.42504629629629 80.001 L 114.42504629629629 80.001 L 102.69717592592592 80.001 Z"
                                cy="35" cx="118.92504629629629" j="3" val="45" barHeight="45"
                                barWidth="20.72787037037037"></path>
                              <path id="SvgjsPath1264"
                                d="M140.38421296296298 74.001L140.38421296296298 26.001000000000005C140.38421296296298 23.001000000000005 143.38421296296298 20.001000000000005 146.38421296296298 20.001000000000005L146.38421296296298 20.001000000000005C149.24814814814818 20.001000000000005 152.11208333333335 23.001000000000005 152.11208333333335 26.001000000000005L152.11208333333335 74.001C152.11208333333335 77.001 149.11208333333335 80.001 146.11208333333335 80.001L146.11208333333335 80.001C143.24814814814818 80.001 140.38421296296298 77.001 140.38421296296298 74.001C140.38421296296298 74.001 140.38421296296298 74.001 140.38421296296298 74.001 "
                                fill="rgba(62,151,255,0.85)" fill-opacity="1" stroke="transparent" stroke-opacity="1"
                                stroke-linecap="round" stroke-width="9" stroke-dasharray="0" class="apexcharts-bar-area"
                                index="0" clip-path="url(#gridRectMasklvd9i8en)"
                                pathTo="M 140.38421296296298 74.001 L 140.38421296296298 26.001 C 140.38421296296298 23.001 143.38421296296298 20.001 146.38421296296298 20.001 L 146.38421296296298 20.001 C 149.24814814814818 20.001 152.11208333333335 23.001 152.11208333333335 26.001 L 152.11208333333335 74.001 C 152.11208333333335 77.001 149.11208333333335 80.001 146.11208333333335 80.001 L 146.11208333333335 80.001 C 143.24814814814818 80.001 140.38421296296298 77.001 140.38421296296298 74.001 Z "
                                pathFrom="M 140.38421296296298 80.001 L 140.38421296296298 80.001 L 152.11208333333335 80.001 L 152.11208333333335 80.001 L 152.11208333333335 80.001 L 152.11208333333335 80.001 L 152.11208333333335 80.001 L 140.38421296296298 80.001 Z"
                                cy="20" cx="156.61208333333335" j="4" val="60" barHeight="60"
                                barWidth="20.72787037037037"></path>
                              <path id="SvgjsPath1266"
                                d="M178.07124999999996 74.001L178.07124999999996 11.001000000000005C178.07124999999996 8.001000000000005 181.07124999999996 5.001000000000005 184.07124999999996 5.001000000000005L184.07124999999996 5.001000000000005C186.93518518518516 5.001000000000005 189.79912037037033 8.001000000000005 189.79912037037033 11.001000000000005L189.79912037037033 74.001C189.79912037037033 77.001 186.79912037037033 80.001 183.79912037037033 80.001L183.79912037037033 80.001C180.93518518518516 80.001 178.07124999999996 77.001 178.07124999999996 74.001C178.07124999999996 74.001 178.07124999999996 74.001 178.07124999999996 74.001 "
                                fill="rgba(62,151,255,0.85)" fill-opacity="1" stroke="transparent" stroke-opacity="1"
                                stroke-linecap="round" stroke-width="9" stroke-dasharray="0" class="apexcharts-bar-area"
                                index="0" clip-path="url(#gridRectMasklvd9i8en)"
                                pathTo="M 178.07124999999996 74.001 L 178.07124999999996 11.001000000000001 C 178.07124999999996 8.001000000000001 181.07124999999996 5.001 184.07124999999996 5.001 L 184.07124999999996 5.001 C 186.93518518518516 5.001 189.79912037037033 8.001000000000001 189.79912037037033 11.001000000000001 L 189.79912037037033 74.001 C 189.79912037037033 77.001 186.79912037037033 80.001 183.79912037037033 80.001 L 183.79912037037033 80.001 C 180.93518518518516 80.001 178.07124999999996 77.001 178.07124999999996 74.001 Z "
                                pathFrom="M 178.07124999999996 80.001 L 178.07124999999996 80.001 L 189.79912037037033 80.001 L 189.79912037037033 80.001 L 189.79912037037033 80.001 L 189.79912037037033 80.001 L 189.79912037037033 80.001 L 178.07124999999996 80.001 Z"
                                cy="5" cx="194.29912037037033" j="5" val="75" barHeight="75" barWidth="20.72787037037037">
                              </path>
                              <path id="SvgjsPath1268"
                                d="M215.758287037037 74.001L215.758287037037 33.001000000000005C215.758287037037 30.001000000000005 218.758287037037 27.001000000000005 221.758287037037 27.001000000000005L221.758287037037 27.001000000000005C224.6222222222222 27.001000000000005 227.48615740740738 30.001000000000005 227.48615740740738 33.001000000000005L227.48615740740738 74.001C227.48615740740738 77.001 224.48615740740738 80.001 221.48615740740738 80.001L221.48615740740738 80.001C218.6222222222222 80.001 215.758287037037 77.001 215.758287037037 74.001C215.758287037037 74.001 215.758287037037 74.001 215.758287037037 74.001 "
                                fill="rgba(62,151,255,0.85)" fill-opacity="1" stroke="transparent" stroke-opacity="1"
                                stroke-linecap="round" stroke-width="9" stroke-dasharray="0" class="apexcharts-bar-area"
                                index="0" clip-path="url(#gridRectMasklvd9i8en)"
                                pathTo="M 215.758287037037 74.001 L 215.758287037037 33.001000000000005 C 215.758287037037 30.001000000000005 218.758287037037 27.001 221.758287037037 27.001 L 221.758287037037 27.001 C 224.6222222222222 27.001 227.48615740740738 30.001000000000005 227.48615740740738 33.001000000000005 L 227.48615740740738 74.001 C 227.48615740740738 77.001 224.48615740740738 80.001 221.48615740740738 80.001 L 221.48615740740738 80.001 C 218.6222222222222 80.001 215.758287037037 77.001 215.758287037037 74.001 Z "
                                pathFrom="M 215.758287037037 80.001 L 215.758287037037 80.001 L 227.48615740740738 80.001 L 227.48615740740738 80.001 L 227.48615740740738 80.001 L 227.48615740740738 80.001 L 227.48615740740738 80.001 L 215.758287037037 80.001 Z"
                                cy="27" cx="231.98615740740738" j="6" val="53" barHeight="53"
                                barWidth="20.72787037037037"></path>
                              <g id="SvgjsG1253" class="apexcharts-bar-goals-markers">
                                <g id="SvgjsG1255" className="apexcharts-bar-goals-groups"
                                  class="apexcharts-hidden-element-shown" clip-path="url(#gridRectMarkerMasklvd9i8en)">
                                </g>
                                <g id="SvgjsG1257" className="apexcharts-bar-goals-groups"
                                  class="apexcharts-hidden-element-shown" clip-path="url(#gridRectMarkerMasklvd9i8en)">
                                </g>
                                <g id="SvgjsG1259" className="apexcharts-bar-goals-groups"
                                  class="apexcharts-hidden-element-shown" clip-path="url(#gridRectMarkerMasklvd9i8en)">
                                </g>
                                <g id="SvgjsG1261" className="apexcharts-bar-goals-groups"
                                  class="apexcharts-hidden-element-shown" clip-path="url(#gridRectMarkerMasklvd9i8en)">
                                </g>
                                <g id="SvgjsG1263" className="apexcharts-bar-goals-groups"
                                  class="apexcharts-hidden-element-shown" clip-path="url(#gridRectMarkerMasklvd9i8en)">
                                </g>
                                <g id="SvgjsG1265" className="apexcharts-bar-goals-groups"
                                  class="apexcharts-hidden-element-shown" clip-path="url(#gridRectMarkerMasklvd9i8en)">
                                </g>
                                <g id="SvgjsG1267" className="apexcharts-bar-goals-groups"
                                  class="apexcharts-hidden-element-shown" clip-path="url(#gridRectMarkerMasklvd9i8en)">
                                </g>
                              </g>
                              <g id="SvgjsG1254" class="apexcharts-bar-shadows apexcharts-hidden-element-shown"></g>
                            </g>
                            <g id="SvgjsG1252" class="apexcharts-datalabels apexcharts-hidden-element-shown"
                              data:realIndex="0"></g>
                          </g>
                          <line id="SvgjsLine1280" x1="-21.43888888888889" y1="0" x2="247.5611111111111" y2="0"
                            stroke="#b6b6b6" stroke-dasharray="0" stroke-width="1" stroke-linecap="butt"
                            class="apexcharts-ycrosshairs"></line>
                          <line id="SvgjsLine1281" x1="-21.43888888888889" y1="0" x2="247.5611111111111" y2="0"
                            stroke-dasharray="0" stroke-width="0" stroke-linecap="butt"
                            class="apexcharts-ycrosshairs-hidden"></line>
                          <g id="SvgjsG1282" class="apexcharts-xaxis" transform="translate(0, 0)">
                            <g id="SvgjsG1283" class="apexcharts-xaxis-texts-g" transform="translate(0, -4)"></g>
                          </g>
                          <g id="SvgjsG1291" class="apexcharts-yaxis-annotations apexcharts-hidden-element-shown"></g>
                          <g id="SvgjsG1292" class="apexcharts-xaxis-annotations apexcharts-hidden-element-shown"></g>
                          <g id="SvgjsG1293" class="apexcharts-point-annotations apexcharts-hidden-element-shown"></g>
                        </g>
                      </svg>
                      <div class="apexcharts-tooltip apexcharts-theme-light" style="left: 35.4389px; top: 15.5px;">
                        <div class="apexcharts-tooltip-title" style="font-family: inherit; font-size: 12px;">Feb: 1</div>
                        <div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex;">
                          <span class="apexcharts-tooltip-marker"
                            style="background-color: rgba(62, 151, 255, 0.85);"></span>
                          <div class="apexcharts-tooltip-text" style="font-family: inherit; font-size: 12px;">
                            <div class="apexcharts-tooltip-y-group"><span class="apexcharts-tooltip-text-y-label">Sales:
                              </span><span class="apexcharts-tooltip-text-y-value">30%</span></div>
                            <div class="apexcharts-tooltip-goals-group"><span
                                class="apexcharts-tooltip-text-goals-label"></span><span
                                class="apexcharts-tooltip-text-goals-value"></span></div>
                            <div class="apexcharts-tooltip-z-group"><span
                                class="apexcharts-tooltip-text-z-label"></span><span
                                class="apexcharts-tooltip-text-z-value"></span></div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light">
                        <div class="apexcharts-yaxistooltip-text"></div>
                      </div>
                    </div>
                  </div>
                  <!--end::Chart-->
                </div>
                <!--end::Card body-->
              </div>
              <!--end::Card widget 6-->


              <!--begin::Card widget 7-->
              <div class="card card-flush h-md-50 mb-xl-10">
                <!--begin::Header-->
                <div class="card-header pt-5">
                  <!--begin::Title-->
                  <div class="card-title d-flex flex-column">
                    <!--begin::Amount-->
                    <span class="fs-2hx fw-bold text-gray-900 me-2 lh-1 ls-n2">6.3k</span>
                    <!--end::Amount-->

                    <!--begin::Subtitle-->
                    <span class="text-gray-500 pt-1 fw-semibold fs-6">New Customers This Month</span>
                    <!--end::Subtitle-->
                  </div>
                  <!--end::Title-->
                </div>
                <!--end::Header-->

                <!--begin::Card body-->
                <div class="card-body d-flex flex-column justify-content-end pe-0">
                  <!--begin::Title-->
                  <span class="fs-6 fw-bolder text-gray-800 d-block mb-2">Today’s Heroes</span>
                  <!--end::Title-->

                  <!--begin::Users group-->
                  <div class="symbol-group symbol-hover flex-nowrap">
                    <div class="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip"
                      data-bs-original-title="Alan Warden" data-kt-initialized="1">
                      <span class="symbol-label bg-warning text-inverse-warning fw-bold">A</span>
                    </div>
                    <div class="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip" aria-label="Michael Eberon"
                      data-bs-original-title="Michael Eberon" data-kt-initialized="1">
                      <img alt="Pic" :src="avatar30011">
                    </div>
                    <div class="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip"
                      data-bs-original-title="Susan Redwood" data-kt-initialized="1">
                      <span class="symbol-label bg-primary text-inverse-primary fw-bold">S</span>
                    </div>
                    <div class="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip" aria-label="Melody Macy"
                      data-bs-original-title="Melody Macy" data-kt-initialized="1">
                      <img alt="Pic" :src="avatar3002">
                    </div>
                    <div class="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip"
                      data-bs-original-title="Perry Matthew" data-kt-initialized="1">
                      <span class="symbol-label bg-danger text-inverse-danger fw-bold">P</span>
                    </div>
                    <div class="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip" aria-label="Barry Walter"
                      data-bs-original-title="Barry Walter" data-kt-initialized="1">
                      <img alt="Pic" :src="avatar30012">
                    </div>
                    <a href="#" class="symbol symbol-35px symbol-circle" data-bs-toggle="modal"
                      data-bs-target="#kt_modal_view_users">
                      <span class="symbol-label bg-light text-gray-400 fs-8 fw-bold">+42</span>
                    </a>
                  </div>
                  <!--end::Users group-->
                </div>
                <!--end::Card body-->
              </div>
              <!--end::Card widget 7-->
            </div>
            <!--end::Col-->

            <!--begin::Col-->
            <div class="col-lg-12 col-xl-12 col-xxl-6 mb-5 mb-xl-0">
              <!--begin::Chart widget 3-->
              <div class="card card-flush overflow-hidden h-md-100">
                <!--begin::Header-->
                <div class="card-header py-5">
                  <!--begin::Title-->
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bold text-gray-900">Sales This Months</span>
                    <span class="text-gray-500 mt-1 fw-semibold fs-6">Users from all channels</span>
                  </h3>
                  <!--end::Title-->

                  <!--begin::Toolbar-->
                  <div class="card-toolbar">
                    <!--begin::Menu-->
                    <button class="btn btn-icon btn-color-gray-500 btn-active-color-primary justify-content-end"
                      data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">

                      <i class="ki-duotone ki-dots-square fs-1"><span class="path1"></span><span
                          class="path2"></span><span class="path3"></span><span class="path4"></span></i>
                    </button>


                    <!--begin::Menu 2-->
                    <div
                      class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px"
                      data-kt-menu="true">
                      <!--begin::Menu item-->
                      <div class="menu-item px-3">
                        <div class="menu-content fs-6 text-gray-900 fw-bold px-3 py-4">Quick Actions</div>
                      </div>
                      <!--end::Menu item-->

                      <!--begin::Menu separator-->
                      <div class="separator mb-3 opacity-75"></div>
                      <!--end::Menu separator-->

                      <!--begin::Menu item-->
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">
                          New Ticket
                        </a>
                      </div>
                      <!--end::Menu item-->

                      <!--begin::Menu item-->
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">
                          New Customer
                        </a>
                      </div>
                      <!--end::Menu item-->

                      <!--begin::Menu item-->
                      <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-start">
                        <!--begin::Menu item-->
                        <a href="#" class="menu-link px-3">
                          <span class="menu-title">New Group</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <!--end::Menu item-->

                        <!--begin::Menu sub-->
                        <div class="menu-sub menu-sub-dropdown w-175px py-4">
                          <!--begin::Menu item-->
                          <div class="menu-item px-3">
                            <a href="#" class="menu-link px-3">
                              Admin Group
                            </a>
                          </div>
                          <!--end::Menu item-->

                          <!--begin::Menu item-->
                          <div class="menu-item px-3">
                            <a href="#" class="menu-link px-3">
                              Staff Group
                            </a>
                          </div>
                          <!--end::Menu item-->

                          <!--begin::Menu item-->
                          <div class="menu-item px-3">
                            <a href="#" class="menu-link px-3">
                              Member Group
                            </a>
                          </div>
                          <!--end::Menu item-->
                        </div>
                        <!--end::Menu sub-->
                      </div>
                      <!--end::Menu item-->

                      <!--begin::Menu item-->
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">
                          New Contact
                        </a>
                      </div>
                      <!--end::Menu item-->

                      <!--begin::Menu separator-->
                      <div class="separator mt-3 opacity-75"></div>
                      <!--end::Menu separator-->

                      <!--begin::Menu item-->
                      <div class="menu-item px-3">
                        <div class="menu-content px-3 py-3">
                          <a class="btn btn-primary  btn-sm px-4" href="#">
                            Generate Reports
                          </a>
                        </div>
                      </div>
                      <!--end::Menu item-->
                    </div>
                    <!--end::Menu 2-->

                    <!--end::Menu-->
                  </div>
                  <!--end::Toolbar-->
                </div>
                <!--end::Header-->

                <!--begin::Card body-->
                <div class="card-body d-flex justify-content-between flex-column pb-1 px-0">
                  <!--begin::Statistics-->
                  <div class="px-9 mb-5">
                    <!--begin::Statistics-->
                    <div class="d-flex mb-2">
                      <span class="fs-4 fw-semibold text-gray-500 me-1">$</span>
                      <span class="fs-2hx fw-bold text-gray-800 me-2 lh-1 ls-n2">14,094</span>
                    </div>
                    <!--end::Statistics-->

                    <!--begin::Description-->
                    <span class="fs-6 fw-semibold text-gray-500">Another $48,346 to Goal</span>
                    <!--end::Description-->
                  </div>
                  <!--end::Statistics-->

                  <!--begin::Chart-->
                  <div id="kt_charts_widget_3" class="min-h-auto ps-4 pe-6" style="height: 300px; min-height: 315px;">
                    <div id="apexcharts4svu4bdl" class="apexcharts-canvas apexcharts4svu4bdl apexcharts-theme-light"
                      style="width: 579.5px; height: 300px;"><svg id="SvgjsSvg1006" width="579.5" height="300"
                        xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:svgjs="http://svgjs.dev" class="apexcharts-svg apexcharts-zoomable"
                        xmlns:data="ApexChartsNS" transform="translate(0, 0)" style="background: transparent;">
                        <foreignObject x="0" y="0" width="579.5" height="300">
                          <div class="apexcharts-legend" xmlns="http://www.w3.org/1999/xhtml" style="max-height: 150px;">
                          </div>
                        </foreignObject>
                        <rect id="SvgjsRect1035" width="0" height="0" x="0" y="0" rx="0" ry="0" opacity="1"
                          stroke-width="0" stroke="none" stroke-dasharray="0" fill="#fefefe"></rect>
                        <g id="SvgjsG1098" class="apexcharts-yaxis" rel="0" transform="translate(27.265625, 0)">
                          <g id="SvgjsG1099" class="apexcharts-yaxis-texts-g"><text id="SvgjsText1101"
                              font-family="inherit" x="20" y="31.4" text-anchor="end" dominant-baseline="auto"
                              font-size="12px" font-weight="400" fill="#99a1b7"
                              class="apexcharts-text apexcharts-yaxis-label " style="font-family: inherit;">
                              <tspan id="SvgjsTspan1102">$24K</tspan>
                              <title>$24K</title>
                            </text><text id="SvgjsText1104" font-family="inherit" x="20" y="86.855" text-anchor="end"
                              dominant-baseline="auto" font-size="12px" font-weight="400" fill="#99a1b7"
                              class="apexcharts-text apexcharts-yaxis-label " style="font-family: inherit;">
                              <tspan id="SvgjsTspan1105">$20.5K</tspan>
                              <title>$20.5K</title>
                            </text><text id="SvgjsText1107" font-family="inherit" x="20" y="142.31" text-anchor="end"
                              dominant-baseline="auto" font-size="12px" font-weight="400" fill="#99a1b7"
                              class="apexcharts-text apexcharts-yaxis-label " style="font-family: inherit;">
                              <tspan id="SvgjsTspan1108">$17K</tspan>
                              <title>$17K</title>
                            </text><text id="SvgjsText1110" font-family="inherit" x="20" y="197.76500000000001"
                              text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400" fill="#99a1b7"
                              class="apexcharts-text apexcharts-yaxis-label " style="font-family: inherit;">
                              <tspan id="SvgjsTspan1111">$13.5K</tspan>
                              <title>$13.5K</title>
                            </text><text id="SvgjsText1113" font-family="inherit" x="20" y="253.22" text-anchor="end"
                              dominant-baseline="auto" font-size="12px" font-weight="400" fill="#99a1b7"
                              class="apexcharts-text apexcharts-yaxis-label " style="font-family: inherit;">
                              <tspan id="SvgjsTspan1114">$10K</tspan>
                              <title>$10K</title>
                            </text></g>
                        </g>
                        <g id="SvgjsG1008" class="apexcharts-inner apexcharts-graphical"
                          transform="translate(57.265625, 30)">
                          <defs id="SvgjsDefs1007">
                            <clipPath id="gridRectMask4svu4bdl">
                              <rect id="SvgjsRect1012" width="519.234375" height="224.82" x="-3.5" y="-1.5" rx="0" ry="0"
                                opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0" fill="#fff"></rect>
                            </clipPath>
                            <clipPath id="forecastMask4svu4bdl"></clipPath>
                            <clipPath id="nonForecastMask4svu4bdl"></clipPath>
                            <clipPath id="gridRectMarkerMask4svu4bdl">
                              <rect id="SvgjsRect1013" width="516.234375" height="225.82" x="-2" y="-2" rx="0" ry="0"
                                opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0" fill="#fff"></rect>
                            </clipPath>
                            <linearGradient id="SvgjsLinearGradient1018" x1="0" y1="0" x2="0" y2="1">
                              <stop id="SvgjsStop1019" stop-opacity="0.4" stop-color="rgba(80,205,137,0.4)" offset="0">
                              </stop>
                              <stop id="SvgjsStop1020" stop-opacity="0" stop-color="rgba(255,255,255,0)" offset="0.8">
                              </stop>
                              <stop id="SvgjsStop1021" stop-opacity="0" stop-color="rgba(255,255,255,0)" offset="1">
                              </stop>
                            </linearGradient>
                          </defs>
                          <g id="SvgjsG1024" class="apexcharts-grid">
                            <g id="SvgjsG1025" class="apexcharts-gridlines-horizontal">
                              <line id="SvgjsLine1029" x1="0" y1="55.455" x2="512.234375" y2="55.455" stroke="#dbdfe9"
                                stroke-dasharray="4" stroke-linecap="butt" class="apexcharts-gridline"></line>
                              <line id="SvgjsLine1030" x1="0" y1="110.91" x2="512.234375" y2="110.91" stroke="#dbdfe9"
                                stroke-dasharray="4" stroke-linecap="butt" class="apexcharts-gridline"></line>
                              <line id="SvgjsLine1031" x1="0" y1="166.365" x2="512.234375" y2="166.365" stroke="#dbdfe9"
                                stroke-dasharray="4" stroke-linecap="butt" class="apexcharts-gridline"></line>
                            </g>
                            <g id="SvgjsG1026" class="apexcharts-gridlines-vertical"></g>
                            <line id="SvgjsLine1034" x1="0" y1="221.82" x2="512.234375" y2="221.82" stroke="transparent"
                              stroke-dasharray="0" stroke-linecap="butt"></line>
                            <line id="SvgjsLine1033" x1="0" y1="1" x2="0" y2="221.82" stroke="transparent"
                              stroke-dasharray="0" stroke-linecap="butt"></line>
                          </g>
                          <g id="SvgjsG1027" class="apexcharts-grid-borders">
                            <line id="SvgjsLine1028" x1="0" y1="0" x2="512.234375" y2="0" stroke="#dbdfe9"
                              stroke-dasharray="4" stroke-linecap="butt" class="apexcharts-gridline"></line>
                            <line id="SvgjsLine1032" x1="0" y1="221.82" x2="512.234375" y2="221.82" stroke="#dbdfe9"
                              stroke-dasharray="4" stroke-linecap="butt" class="apexcharts-gridline"></line>
                          </g>
                          <g id="SvgjsG1014" class="apexcharts-area-series apexcharts-plot-series">
                            <g id="SvgjsG1015" class="apexcharts-series" seriesName="Sales" data:longestSeries="true"
                              rel="1" data:realIndex="0">
                              <path id="SvgjsPath1022"
                                d="M0 221.82L0 95.06571428571425C9.960112847222222 95.06571428571425 18.49735243055556 95.06571428571425 28.45746527777778 95.06571428571425C38.417578125 95.06571428571425 46.95481770833334 63.377142857142815 56.91493055555556 63.377142857142815C66.87504340277778 63.377142857142815 75.41228298611112 63.377142857142815 85.37239583333334 63.377142857142815C95.33250868055556 63.377142857142815 103.8697482638889 95.06571428571425 113.82986111111111 95.06571428571425C123.78997395833333 95.06571428571425 132.32721354166665 95.06571428571425 142.28732638888889 95.06571428571425C152.24743923611112 95.06571428571425 160.78467881944445 31.68857142857138 170.74479166666669 31.68857142857138C180.7049045138889 31.68857142857138 189.24214409722225 31.68857142857138 199.20225694444446 31.68857142857138C209.16236979166666 31.68857142857138 217.69960937500002 63.377142857142815 227.65972222222223 63.377142857142815C237.61983506944443 63.377142857142815 246.1570746527778 63.377142857142815 256.1171875 63.377142857142815C266.0773003472222 63.377142857142815 274.61453993055557 95.06571428571425 284.57465277777777 95.06571428571425C294.53476562500003 95.06571428571425 303.07200520833334 95.06571428571425 313.0321180555556 95.06571428571425C322.9922309027778 95.06571428571425 331.52947048611117 63.377142857142815 341.48958333333337 63.377142857142815C351.4496961805556 63.377142857142815 359.98693576388894 63.377142857142815 369.94704861111114 63.377142857142815C379.90716145833335 63.377142857142815 388.4444010416667 95.06571428571425 398.4045138888889 95.06571428571425C408.3646267361111 95.06571428571425 416.9018663194445 95.06571428571425 426.8619791666667 95.06571428571425C436.8220920138889 95.06571428571425 445.35933159722225 63.377142857142815 455.31944444444446 63.377142857142815C465.2795572916667 63.377142857142815 473.816796875 63.377142857142815 483.7769097222223 63.377142857142815C493.7370225694445 63.377142857142815 502.2742621527778 31.68857142857138 512.234375 31.68857142857138C512.234375 31.68857142857138 512.234375 31.68857142857138 512.234375 221.82M512.234375 31.68857142857138C512.234375 31.68857142857138 512.234375 31.68857142857138 512.234375 31.68857142857138 "
                                fill="url(#SvgjsLinearGradient1018)" fill-opacity="1" stroke-opacity="1"
                                stroke-linecap="butt" stroke-width="0" stroke-dasharray="0" class="apexcharts-area"
                                index="0" clip-path="url(#gridRectMask4svu4bdl)"
                                pathTo="M 0 221.82 L 0 95.06571428571425C 9.960112847222222 95.06571428571425 18.49735243055556 95.06571428571425 28.45746527777778 95.06571428571425C 38.417578125 95.06571428571425 46.95481770833334 63.377142857142815 56.91493055555556 63.377142857142815C 66.87504340277778 63.377142857142815 75.41228298611112 63.377142857142815 85.37239583333334 63.377142857142815C 95.33250868055556 63.377142857142815 103.8697482638889 95.06571428571425 113.82986111111111 95.06571428571425C 123.78997395833333 95.06571428571425 132.32721354166665 95.06571428571425 142.28732638888889 95.06571428571425C 152.24743923611112 95.06571428571425 160.78467881944445 31.68857142857138 170.74479166666669 31.68857142857138C 180.7049045138889 31.68857142857138 189.24214409722225 31.68857142857138 199.20225694444446 31.68857142857138C 209.16236979166666 31.68857142857138 217.69960937500002 63.377142857142815 227.65972222222223 63.377142857142815C 237.61983506944443 63.377142857142815 246.1570746527778 63.377142857142815 256.1171875 63.377142857142815C 266.0773003472222 63.377142857142815 274.61453993055557 95.06571428571425 284.57465277777777 95.06571428571425C 294.53476562500003 95.06571428571425 303.07200520833334 95.06571428571425 313.0321180555556 95.06571428571425C 322.9922309027778 95.06571428571425 331.52947048611117 63.377142857142815 341.48958333333337 63.377142857142815C 351.4496961805556 63.377142857142815 359.98693576388894 63.377142857142815 369.94704861111114 63.377142857142815C 379.90716145833335 63.377142857142815 388.4444010416667 95.06571428571425 398.4045138888889 95.06571428571425C 408.3646267361111 95.06571428571425 416.9018663194445 95.06571428571425 426.8619791666667 95.06571428571425C 436.8220920138889 95.06571428571425 445.35933159722225 63.377142857142815 455.31944444444446 63.377142857142815C 465.2795572916667 63.377142857142815 473.816796875 63.377142857142815 483.7769097222223 63.377142857142815C 493.7370225694445 63.377142857142815 502.2742621527778 31.68857142857138 512.234375 31.68857142857138C 512.234375 31.68857142857138 512.234375 31.68857142857138 512.234375 221.82M 512.234375 31.68857142857138z"
                                pathFrom="M -1 380.2628571428571 L -1 380.2628571428571 L 28.45746527777778 380.2628571428571 L 56.91493055555556 380.2628571428571 L 85.37239583333334 380.2628571428571 L 113.82986111111111 380.2628571428571 L 142.28732638888889 380.2628571428571 L 170.74479166666669 380.2628571428571 L 199.20225694444446 380.2628571428571 L 227.65972222222223 380.2628571428571 L 256.1171875 380.2628571428571 L 284.57465277777777 380.2628571428571 L 313.0321180555556 380.2628571428571 L 341.48958333333337 380.2628571428571 L 369.94704861111114 380.2628571428571 L 398.4045138888889 380.2628571428571 L 426.8619791666667 380.2628571428571 L 455.31944444444446 380.2628571428571 L 483.7769097222223 380.2628571428571 L 512.234375 380.2628571428571">
                              </path>
                              <path id="SvgjsPath1023"
                                d="M0 95.06571428571425C9.960112847222222 95.06571428571425 18.49735243055556 95.06571428571425 28.45746527777778 95.06571428571425C38.417578125 95.06571428571425 46.95481770833334 63.377142857142815 56.91493055555556 63.377142857142815C66.87504340277778 63.377142857142815 75.41228298611112 63.377142857142815 85.37239583333334 63.377142857142815C95.33250868055556 63.377142857142815 103.8697482638889 95.06571428571425 113.82986111111111 95.06571428571425C123.78997395833333 95.06571428571425 132.32721354166665 95.06571428571425 142.28732638888889 95.06571428571425C152.24743923611112 95.06571428571425 160.78467881944445 31.68857142857138 170.74479166666669 31.68857142857138C180.7049045138889 31.68857142857138 189.24214409722225 31.68857142857138 199.20225694444446 31.68857142857138C209.16236979166666 31.68857142857138 217.69960937500002 63.377142857142815 227.65972222222223 63.377142857142815C237.61983506944443 63.377142857142815 246.1570746527778 63.377142857142815 256.1171875 63.377142857142815C266.0773003472222 63.377142857142815 274.61453993055557 95.06571428571425 284.57465277777777 95.06571428571425C294.53476562500003 95.06571428571425 303.07200520833334 95.06571428571425 313.0321180555556 95.06571428571425C322.9922309027778 95.06571428571425 331.52947048611117 63.377142857142815 341.48958333333337 63.377142857142815C351.4496961805556 63.377142857142815 359.98693576388894 63.377142857142815 369.94704861111114 63.377142857142815C379.90716145833335 63.377142857142815 388.4444010416667 95.06571428571425 398.4045138888889 95.06571428571425C408.3646267361111 95.06571428571425 416.9018663194445 95.06571428571425 426.8619791666667 95.06571428571425C436.8220920138889 95.06571428571425 445.35933159722225 63.377142857142815 455.31944444444446 63.377142857142815C465.2795572916667 63.377142857142815 473.816796875 63.377142857142815 483.7769097222223 63.377142857142815C493.7370225694445 63.377142857142815 502.2742621527778 31.68857142857138 512.234375 31.68857142857138C512.234375 31.68857142857138 512.234375 31.68857142857138 512.234375 31.68857142857138 "
                                fill="none" fill-opacity="1" stroke="#50cd89" stroke-opacity="1" stroke-linecap="butt"
                                stroke-width="3" stroke-dasharray="0" class="apexcharts-area" index="0"
                                clip-path="url(#gridRectMask4svu4bdl)"
                                pathTo="M 0 95.06571428571425C 9.960112847222222 95.06571428571425 18.49735243055556 95.06571428571425 28.45746527777778 95.06571428571425C 38.417578125 95.06571428571425 46.95481770833334 63.377142857142815 56.91493055555556 63.377142857142815C 66.87504340277778 63.377142857142815 75.41228298611112 63.377142857142815 85.37239583333334 63.377142857142815C 95.33250868055556 63.377142857142815 103.8697482638889 95.06571428571425 113.82986111111111 95.06571428571425C 123.78997395833333 95.06571428571425 132.32721354166665 95.06571428571425 142.28732638888889 95.06571428571425C 152.24743923611112 95.06571428571425 160.78467881944445 31.68857142857138 170.74479166666669 31.68857142857138C 180.7049045138889 31.68857142857138 189.24214409722225 31.68857142857138 199.20225694444446 31.68857142857138C 209.16236979166666 31.68857142857138 217.69960937500002 63.377142857142815 227.65972222222223 63.377142857142815C 237.61983506944443 63.377142857142815 246.1570746527778 63.377142857142815 256.1171875 63.377142857142815C 266.0773003472222 63.377142857142815 274.61453993055557 95.06571428571425 284.57465277777777 95.06571428571425C 294.53476562500003 95.06571428571425 303.07200520833334 95.06571428571425 313.0321180555556 95.06571428571425C 322.9922309027778 95.06571428571425 331.52947048611117 63.377142857142815 341.48958333333337 63.377142857142815C 351.4496961805556 63.377142857142815 359.98693576388894 63.377142857142815 369.94704861111114 63.377142857142815C 379.90716145833335 63.377142857142815 388.4444010416667 95.06571428571425 398.4045138888889 95.06571428571425C 408.3646267361111 95.06571428571425 416.9018663194445 95.06571428571425 426.8619791666667 95.06571428571425C 436.8220920138889 95.06571428571425 445.35933159722225 63.377142857142815 455.31944444444446 63.377142857142815C 465.2795572916667 63.377142857142815 473.816796875 63.377142857142815 483.7769097222223 63.377142857142815C 493.7370225694445 63.377142857142815 502.2742621527778 31.68857142857138 512.234375 31.68857142857138"
                                pathFrom="M -1 380.2628571428571 L -1 380.2628571428571 L 28.45746527777778 380.2628571428571 L 56.91493055555556 380.2628571428571 L 85.37239583333334 380.2628571428571 L 113.82986111111111 380.2628571428571 L 142.28732638888889 380.2628571428571 L 170.74479166666669 380.2628571428571 L 199.20225694444446 380.2628571428571 L 227.65972222222223 380.2628571428571 L 256.1171875 380.2628571428571 L 284.57465277777777 380.2628571428571 L 313.0321180555556 380.2628571428571 L 341.48958333333337 380.2628571428571 L 369.94704861111114 380.2628571428571 L 398.4045138888889 380.2628571428571 L 426.8619791666667 380.2628571428571 L 455.31944444444446 380.2628571428571 L 483.7769097222223 380.2628571428571 L 512.234375 380.2628571428571"
                                fill-rule="evenodd"></path>
                              <g id="SvgjsG1016" class="apexcharts-series-markers-wrap apexcharts-hidden-element-shown"
                                data:realIndex="0">
                                <g class="apexcharts-series-markers">
                                  <circle id="SvgjsCircle1118" r="0" cx="0" cy="0"
                                    class="apexcharts-marker wzbngo6be no-pointer-events" stroke="#50cd89" fill="#50cd89"
                                    fill-opacity="1" stroke-width="3" stroke-opacity="0.9" default-marker-size="0">
                                  </circle>
                                </g>
                              </g>
                            </g>
                            <g id="SvgjsG1017" class="apexcharts-datalabels" data:realIndex="0"></g>
                          </g>
                          <line id="SvgjsLine1036" x1="0" y1="0" x2="0" y2="221.82" stroke="#50cd89" stroke-dasharray="3"
                            stroke-linecap="butt" class="apexcharts-xcrosshairs" x="0" y="0" width="1" height="221.82"
                            fill="#b1b9c4" filter="none" fill-opacity="0.9" stroke-width="1"></line>
                          <line id="SvgjsLine1037" x1="0" y1="0" x2="512.234375" y2="0" stroke="#b6b6b6"
                            stroke-dasharray="0" stroke-width="1" stroke-linecap="butt" class="apexcharts-ycrosshairs">
                          </line>
                          <line id="SvgjsLine1038" x1="0" y1="0" x2="512.234375" y2="0" stroke-dasharray="0"
                            stroke-width="0" stroke-linecap="butt" class="apexcharts-ycrosshairs-hidden"></line>
                          <g id="SvgjsG1039" class="apexcharts-xaxis" transform="translate(0, 0)">
                            <g id="SvgjsG1040" class="apexcharts-xaxis-texts-g" transform="translate(0, -10)"><text
                                id="SvgjsText1042" font-family="inherit" x="0" y="244.82" text-anchor="end"
                                dominant-baseline="auto" font-size="12px" font-weight="400" fill="#99a1b7"
                                class="apexcharts-text apexcharts-xaxis-label " style="font-family: inherit;"
                                transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1043"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1045" font-family="inherit" x="28.457465277777782" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1046"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1048" font-family="inherit" x="56.91493055555557" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1049"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1051" font-family="inherit" x="85.37239583333334" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 86.37239837646484 239.32000732421875)">
                                <tspan id="SvgjsTspan1052">Apr 04</tspan>
                                <title>Apr 04</title>
                              </text><text id="SvgjsText1054" font-family="inherit" x="113.82986111111111" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1055"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1057" font-family="inherit" x="142.28732638888889" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1058"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1060" font-family="inherit" x="170.74479166666666" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 171.7447967529297 239.32000732421875)">
                                <tspan id="SvgjsTspan1061">Apr 07</tspan>
                                <title>Apr 07</title>
                              </text><text id="SvgjsText1063" font-family="inherit" x="199.20225694444443" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1064"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1066" font-family="inherit" x="227.6597222222222" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1067"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1069" font-family="inherit" x="256.11718749999994" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 257.1171875 239.32000732421875)">
                                <tspan id="SvgjsTspan1070">Apr 10</tspan>
                                <title>Apr 10</title>
                              </text><text id="SvgjsText1072" font-family="inherit" x="284.5746527777777" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1073"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1075" font-family="inherit" x="313.0321180555555" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1076"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1078" font-family="inherit" x="341.48958333333326" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 342.4895935058594 239.32000732421875)">
                                <tspan id="SvgjsTspan1079">Apr 13</tspan>
                                <title>Apr 13</title>
                              </text><text id="SvgjsText1081" font-family="inherit" x="369.94704861111103" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1082"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1084" font-family="inherit" x="398.4045138888888" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1085"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1087" font-family="inherit" x="426.8619791666666" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 427.8619689941406 239.32000732421875)">
                                <tspan id="SvgjsTspan1088">Apr 16</tspan>
                                <title>Apr 16</title>
                              </text><text id="SvgjsText1090" font-family="inherit" x="455.31944444444434" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1091"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1093" font-family="inherit" x="483.7769097222221" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1094"></tspan>
                                <title></title>
                              </text><text id="SvgjsText1096" font-family="inherit" x="512.2343749999999" y="244.82"
                                text-anchor="end" dominant-baseline="auto" font-size="12px" font-weight="400"
                                fill="#99a1b7" class="apexcharts-text apexcharts-xaxis-label "
                                style="font-family: inherit;" transform="rotate(0 1 -1)">
                                <tspan id="SvgjsTspan1097"></tspan>
                                <title></title>
                              </text></g>
                          </g>
                          <g id="SvgjsG1115" class="apexcharts-yaxis-annotations apexcharts-hidden-element-shown"></g>
                          <g id="SvgjsG1116" class="apexcharts-xaxis-annotations apexcharts-hidden-element-shown"></g>
                          <g id="SvgjsG1117" class="apexcharts-point-annotations apexcharts-hidden-element-shown"></g>
                          <rect id="SvgjsRect1119" width="0" height="0" x="0" y="0" rx="0" ry="0" opacity="1"
                            stroke-width="0" stroke="none" stroke-dasharray="0" fill="#fefefe"
                            class="apexcharts-zoom-rect"></rect>
                          <rect id="SvgjsRect1120" width="0" height="0" x="0" y="0" rx="0" ry="0" opacity="1"
                            stroke-width="0" stroke="none" stroke-dasharray="0" fill="#fefefe"
                            class="apexcharts-selection-rect"></rect>
                        </g>
                      </svg>
                      <div class="apexcharts-tooltip apexcharts-theme-light">
                        <div class="apexcharts-tooltip-title" style="font-family: inherit; font-size: 12px;"></div>
                        <div class="apexcharts-tooltip-series-group" style="order: 1;"><span
                            class="apexcharts-tooltip-marker" style="background-color: rgb(80, 205, 137);"></span>
                          <div class="apexcharts-tooltip-text" style="font-family: inherit; font-size: 12px;">
                            <div class="apexcharts-tooltip-y-group"><span
                                class="apexcharts-tooltip-text-y-label"></span><span
                                class="apexcharts-tooltip-text-y-value"></span></div>
                            <div class="apexcharts-tooltip-goals-group"><span
                                class="apexcharts-tooltip-text-goals-label"></span><span
                                class="apexcharts-tooltip-text-goals-value"></span></div>
                            <div class="apexcharts-tooltip-z-group"><span
                                class="apexcharts-tooltip-text-z-label"></span><span
                                class="apexcharts-tooltip-text-z-value"></span></div>
                          </div>
                        </div>
                      </div>
                      <div class="apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom apexcharts-theme-light">
                        <div class="apexcharts-xaxistooltip-text" style="font-family: inherit; font-size: 12px;"></div>
                      </div>
                      <div
                        class="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light">
                        <div class="apexcharts-yaxistooltip-text"></div>
                      </div>
                    </div>
                  </div>
                  <!--end::Chart-->
                </div>
                <!--end::Card body-->
              </div>
              <!--end::Chart widget 3-->
            </div>
            <!--end::Col-->
          </div>
          <!--end::Row-->

          <div class="row gy-5 g-xl-10">
            <div class="col-xl-12 mb-5 mb-xl-10">
              <div class="card card-flush h-xl-100">
                <div class="card-header pt-7">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label fw-bold text-gray-800">Product Orders</span>
                    <span class="text-gray-500 mt-1 fw-semibold fs-6">Avg. 57 orders per day</span>
                  </h3>
                  <div class="card-toolbar">
                    <div class="d-flex flex-stack flex-wrap gap-4">
                      <div class="d-flex align-items-center fw-bold">
                        <div class="text-gray-500 fs-7 me-2">Cateogry</div>
                        <select
                          class="form-select form-select-transparent text-graY-800 fs-base lh-1 fw-bold py-0 ps-3 w-auto select2-hidden-accessible"
                          data-control="select2" data-hide-search="true" data-dropdown-css-class="w-150px"
                          data-placeholder="Select an option" data-select2-id="select2-data-7-19es" tabindex="-1"
                          aria-hidden="true" data-kt-initialized="1">
                          <option></option>
                          <option value="Show All" selected="" data-select2-id="select2-data-9-1pye">Show All</option>
                          <option value="a">Category A</option>
                          <option value="b">Category A</option>
                        </select><span class="select2 select2-container select2-container--bootstrap5" dir="ltr"
                          data-select2-id="select2-data-8-ij99" style="width: 100%;"><span class="selection"><span
                              class="select2-selection select2-selection--single form-select form-select-transparent text-graY-800 fs-base lh-1 fw-bold py-0 ps-3 w-auto"
                              role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="0"
                              aria-disabled="false" aria-labelledby="select2-g8gp-container"
                              aria-controls="select2-g8gp-container"><span class="select2-selection__rendered"
                                id="select2-g8gp-container" role="textbox" aria-readonly="true" title="Show All">Show
                                All</span><span class="select2-selection__arrow" role="presentation"><b
                                  role="presentation"></b></span></span></span><span class="dropdown-wrapper"
                            aria-hidden="true"></span></span>
                      </div>
                      <div class="d-flex align-items-center fw-bold">
                        <div class="text-gray-500 fs-7 me-2">Status</div>
                        <select
                          class="form-select form-select-transparent text-gray-900 fs-7 lh-1 fw-bold py-0 ps-3 w-auto select2-hidden-accessible"
                          data-control="select2" data-hide-search="true" data-dropdown-css-class="w-150px"
                          data-placeholder="Select an option" data-kt-table-widget-4="filter_status"
                          data-select2-id="select2-data-10-yzee" tabindex="-1" aria-hidden="true" data-kt-initialized="1">
                          <option></option>
                          <option value="Show All" selected="" data-select2-id="select2-data-12-l1wc">Show All</option>
                          <option value="Shipped">Shipped</option>
                          <option value="Confirmed">Confirmed</option>
                          <option value="Rejected">Rejected</option>
                          <option value="Pending">Pending</option>
                        </select><span class="select2 select2-container select2-container--bootstrap5" dir="ltr"
                          data-select2-id="select2-data-11-2jiw" style="width: 100%;"><span class="selection"><span
                              class="select2-selection select2-selection--single form-select form-select-transparent text-gray-900 fs-7 lh-1 fw-bold py-0 ps-3 w-auto"
                              role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="0"
                              aria-disabled="false" aria-labelledby="select2-dm6v-container"
                              aria-controls="select2-dm6v-container"><span class="select2-selection__rendered"
                                id="select2-dm6v-container" role="textbox" aria-readonly="true" title="Show All">Show
                                All</span><span class="select2-selection__arrow" role="presentation"><b
                                  role="presentation"></b></span></span></span><span class="dropdown-wrapper"
                            aria-hidden="true"></span></span>
                      </div>
                      <div class="position-relative my-1">
                        <i class="ki-duotone ki-magnifier fs-2 position-absolute top-50 translate-middle-y ms-4"><span
                            class="path1"></span><span class="path2"></span></i> <input type="text"
                          data-kt-table-widget-4="search" class="form-control w-150px fs-7 ps-12" placeholder="Search">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-2">
                  <div id="kt_table_widget_4_table_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div class="table-responsive">
                      <table class="table align-middle table-row-dashed fs-6 gy-3 dataTable no-footer"
                        id="kt_table_widget_4_table">
                        <thead>
                          <tr class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                            <th class="min-w-100px sorting_disabled" rowspan="1" colspan="1" style="width: 101.797px;">
                              Order ID</th>
                            <th class="text-end min-w-100px sorting_disabled" rowspan="1" colspan="1"
                              style="width: 101.953px;">Created</th>
                            <th class="text-end min-w-125px sorting_disabled" rowspan="1" colspan="1"
                              style="width: 127.375px;">Customer</th>
                            <th class="text-end min-w-100px sorting_disabled" rowspan="1" colspan="1"
                              style="width: 101.953px;">Total</th>
                            <th class="text-end min-w-100px sorting_disabled" rowspan="1" colspan="1"
                              style="width: 101.953px;">Profit</th>
                            <th class="text-end min-w-50px sorting_disabled" rowspan="1" colspan="1"
                              style="width: 90.9844px;">Status</th>
                            <th class="text-end sorting_disabled" rowspan="1" colspan="1" style="width: 25.6406px;"></th>
                          </tr>
                        </thead>
                        <tbody class="fw-bold text-gray-600">
                          <tr class="odd">
                            <td>
                              <a href="/metronic8/demo1/../demo1/apps/ecommerce/catalog/edit-product.html"
                                class="text-gray-800 text-hover-primary">#XGY-346</a>
                            </td>

                            <td class="text-end">
                              7 min ago
                            </td>

                            <td class="text-end">
                              <a href="#" class="text-gray-600 text-hover-primary">Albert Flores</a>
                            </td>

                            <td class="text-end">
                              $630.00 </td>

                            <td class="text-end">
                              <span class="text-gray-800 fw-bolder">$86.70</span>
                            </td>

                            <td class="text-end">
                              <span class="badge py-3 px-4 fs-7 badge-light-warning">Pending</span>
                            </td>

                            <td class="text-end">
                              <button type="button"
                                class="btn btn-sm btn-icon btn-light btn-active-light-primary toggle h-25px w-25px"
                                data-kt-table-widget-4="expand_row">
                                <i class="ki-duotone ki-plus fs-4 m-0 toggle-off"></i> <i
                                  class="ki-duotone ki-minus fs-4 m-0 toggle-on"></i> </button>
                            </td>
                          </tr>
                          <tr class="even">
                            <td>
                              <a href="/metronic8/demo1/../demo1/apps/ecommerce/catalog/edit-product.html"
                                class="text-gray-800 text-hover-primary">#YHD-047</a>
                            </td>

                            <td class="text-end">
                              52 min ago
                            </td>

                            <td class="text-end">
                              <a href="#" class="text-gray-600 text-hover-primary">Jenny Wilson</a>
                            </td>

                            <td class="text-end">
                              $25.00 </td>

                            <td class="text-end">
                              <span class="text-gray-800 fw-bolder">$4.20</span>
                            </td>

                            <td class="text-end">
                              <span class="badge py-3 px-4 fs-7 badge-light-primary">Confirmed</span>
                            </td>

                            <td class="text-end">
                              <button type="button"
                                class="btn btn-sm btn-icon btn-light btn-active-light-primary toggle h-25px w-25px"
                                data-kt-table-widget-4="expand_row">
                                <i class="ki-duotone ki-plus fs-4 m-0 toggle-off"></i> <i
                                  class="ki-duotone ki-minus fs-4 m-0 toggle-on"></i> </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start">
                      </div>
                      <div
                        class="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <!--end::Content container-->
      </div>

  </div>
</div></template>
  

  <script setup>
import avatar30011 from '~/tema/src/media/avatars/300-11.jpg'
import avatar30012 from '~/tema/src/media/avatars/300-12.jpg'
import avatar3002 from '~/tema/src/media/avatars/300-2.jpg'
</script>

<script>


import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

export default {
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  data() {
    return {
      editmode: false,
      vizualizare: true,
      profil: {},
      orase: [],
      setari_form: {
        theme: "bootstrap",
        placeholder: "Selectează din listă",
        width: "369px",
      },
      setari_form_orase: {
        theme: "bootstrap",
        placeholder: "Selectează din listă",
        width: "369px",
        dropdownParent: ('.modal-content'),
        language: {
          searching: function () {
            return "Cautare...";
          },
          loadingMore: function () {
            return 'Se încarcă...';
          },
        },
        ajax: {
          url: '/api/utile/iaorase',
          dataType: 'json',
          delay: 350,
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          },
          data: function (params) {
            return {
              q: params.term, // search term
              page: params.page || 1
            };
          },
          processResults: function (data, params) {
            //console.log(data.data);
            // parse the results into the format expected by Select2
            // since we are using custom formatting functions we do not need to
            // alter the remote JSON data, except to indicate that infinite
            // scrolling can be used
            params.page = params.page || 1;

            return {
              results: data.data,
              pagination: {
                more: (params.page * 15) < data.total
              }
            };
          },
          cache: true
          // Additional AJAX parameters go here; see the end of this chapter for the full code of this example

        },
      },


      // Create a new form instance
      form: new Form({
        id: '',
        tip_cont: '',
        nickname: '',
        denumire: '',
        cui: '',
        adresa: '',
        oras: '',
        telefon: '',
        despre_mine: '',

      })
    }
  },
  beforeCreate() {
    //let tip_cont = document.querySelector("meta[name='tip_cont']").getAttribute('content');
    //console.log(localStorage.tip_cont);
    //this.$zo.setRoles([tip_cont]);
    //console.log(localStorage.language);
    //this.$i18n.locale = localStorage.language;
    //console.log(localStorage.getItem('language'));
  },
  mounted() {
    if (localStorage.Lang != null) this.$i18n.locale = localStorage.Lang;
  },
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    getResults(page = 1) {
      axios.get('/api/utile/anunturi?page=' + page)
        .then(response => {
          this.anunturi = response.data;
        });
    },
    Modal_CreeazaProfilul() {
      this.editmode = false;
      this.form.reset();
      $('#ProfilModal').modal('show');

    },
    TrimiteProfil() {
      this.form.post('/api/cont/addprofil')
        .then(() => {
          emitter.emit("AfterCreate");
          //Updateds.$emit('AfterCreate');
          $('#ProfilModal').modal('hide')
          toast.fire({
            type: 'success',
            title: 'Profilul a fost creeat!'
          })
        })
        .catch(() => {
          console.log('A fost o eroare la trimiterea profilului')
        })
    },
    incarcaProfil() {
      axios.get("/api/cont/vprofil", {
        headers: {
          //Authorization: 'Bearer 49|7PJbQy1Jel1RESWvnHRJ0BU4M945W4zxlAqTZ7Lz',
          //Accept: 'application/json'
        }
      })
        .then((response) => {
          //console.log(response.data.length);
          if (response.data.length == 0) {
            this.profil = null;
          }
          else {
            this.profil = response.data;
          }
        })
        .catch((e) => {
          console.log('A aparut o eroare la incarcarea profilului.');
          console.log(e);
        })
    },
  },
  created() {
    emitter.on('searching', () => {
      let query = this.$parent.search;
      axios.get('/api/management/cautaUtilizator?q=' + query)
        .then((data) => {
          this.Anunturi = data.data

        })
        .catch(() => {

        })
    })

    //this.incarcaProfil();
    emitter.on('AfterCreate', () => {
      this.incarcaProfil();
    });
  },

  //mounted() {
  //  console.log('Home component mounted!');
  //}
}
</script>
  
<style lang="scss" scoped>.icon-mare-24 {
  font-size: 24px
}

.icon-mare-20 {
  font-size: 20px
}

.carousel__item {
  min-height: 450px;
  width: 100%;
  background-color: var(--vc-clr-primary);
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-attachment: fixed;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;

}

.carousel__item_mobile {
  min-height: 200px;
  width: 100%;
  background-color: var(--vc-clr-primary);
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-attachment: fixed;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;

}

.carousel__item_produse_noi {
  min-height: 350px;
  width: 100%;
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.landing-dark-bg {
  background-color: #000000;
}

.landing-dark-color {
  color: #000000;
}</style>
  